export const maybeGetComputedStyle = (() => {
  let prevNode;
  let prevStyles;
  return (win, element) => {
    if (prevNode !== element) {
      prevNode = element;
      try {
        prevStyles = win.getComputedStyle(element);
      } catch (e) {
        console.warn(e);
        return undefined;
      }
    }
    return prevStyles;
  };
})();